import * as React from 'react';

import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';
import type {SidebarSectionLink} from 'shells/setup/sidebar-section/sidebar-section';

import {UNLICENSED_USERS_TITLE} from '../users-table/helpers';

export type Props = {
    enabledUsers: {
        count: number;
        urlPath: string;
    };
    unmanagedUsers: {
        count: number;
        urlPath: string;
    };
    disabledUsers: {
        count: number;
        urlPath: string;
    };
    unlicensedUsers: {
        count: number;
        urlPath: string;
    };
    pendingUsers: {
        count: number;
        urlPath: string;
    };
};

export function UsersSidebarSection(props: Props) {
    const {enabledUsers, disabledUsers, pendingUsers, unmanagedUsers, unlicensedUsers} = props;

    const userLinks: SidebarSectionLink[] = [];

    userLinks.push(
        // Enabled users
        {
            to: enabledUsers.urlPath,
            label: 'Enabled users',
            isActive:
                window.location.href.includes(enabledUsers.urlPath) ||
                (window.location.pathname === '/setup/user' && !window.location.search),
            count: enabledUsers.count,
        }
    );

    if (NutClientConfig.hasDirectorySyncConfigured) {
        userLinks.push(
            // Unmanaged users
            {
                to: unmanagedUsers.urlPath,
                label: 'Unmanaged users',
                isActive: window.location.href.includes(unmanagedUsers.urlPath),
                count: unmanagedUsers.count,
            }
        );
    }

    userLinks.push(
        // Disabled users
        {
            to: disabledUsers.urlPath,
            label: 'Removed users',
            isActive: window.location.href.includes(disabledUsers.urlPath),
            count: disabledUsers.count,
        }
    );

    if (unlicensedUsers.count) {
        // Unlicensed users
        userLinks.push({
            to: unlicensedUsers.urlPath,
            label: UNLICENSED_USERS_TITLE,
            isActive: window.location.href.includes(unlicensedUsers.urlPath),
            count: unlicensedUsers.count,
        });
    }

    // Pending users (only if there are any)
    if (pendingUsers.count) {
        userLinks.push({
            to: pendingUsers.urlPath,
            label: 'Pending users',
            isActive: window.location.href.includes(pendingUsers.urlPath),
            count: pendingUsers.count,
        });
    }

    return <SidebarSection title='Users' links={userLinks} />;
}
